import { shouldShowLabelGenerationBanner } from './improveRetrainPending';

/**
 * Which docked bottom-right banner the task page should show. Only one is
 * visible at a time: an active training wins, then the Improve & Retrain
 * label-generation continue card, then a scheduled auto-train.
 *
 * @returns {'training' | 'label-generation' | 'auto-train' | null}
 */
export function taskActiveBanner({ showTrainingProgressCard, usecase } = {}) {
    if (showTrainingProgressCard) return 'training';
    if (shouldShowLabelGenerationBanner(usecase?.improve_retrain_pending)) return 'label-generation';
    if (usecase?.auto_train_pending) return 'auto-train';
    return null;
}
